import React from 'react';
import { EntityTaskDetails } from 'components/common/tasks/entityTaskDetails';
import { useParams } from 'react-router-dom';
import { useDealByIdQuery } from 'api';

export const DealTaskDetails = () => {
  const { id } = useParams() as { id: string };
  const { data: { isFinalStatus } = {} } = useDealByIdQuery({ id }, { skip: !id });
  return <EntityTaskDetails entityName={'DEAL'} isFinalStatus={isFinalStatus} />;
};
